// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import { LOCAL_BUSINESS, injectJsonLd } from "./schema.config";
import VueAxios from "vue-axios";

// import moment from 'moment'

import axios from "axios";
// sweetalert2 ($swal) is lazy-loaded on first alert — see src/utils/swal.js (kept off the initial bundle).
import BootstrapVue from "bootstrap-vue";
import VueLazyload from "vue-lazyload";
import VueMeta from "vue-meta";
import VueSocialSharing from "vue-social-sharing";
// vue2-google-maps is NOT imported globally — it's lazy-loaded only on interactive-map routes
// via src/utils/googleMaps.js + the router guard (keeps the maps wrapper off public pages).

// vue-multi-date-picker REMOVED (dead — only appears in commented-out <m-date-picker>; the active
// <date-picker> is vuejs-datepicker / vue-persian-datetime-picker, already async-chunked).
// v-viewer is lazy-installed once the user is AUTHENTICATED (used only on authed pages) — see
// src/utils/viewer.js + the auth gate in src/router/index.js. Keeps viewerjs off the logged-out/public
// bundle (homepage/listings/blog/FT-PT — what PageSpeed measures).
// Global cropperjs styles — ensures every vue-cropper instance is styled (Edit.vue didn't
// import it, causing a mis-sized .cropper-container / very tall Edit Image modal).
import "cropperjs/dist/cropper.css";
import moment from "moment-timezone";
import { installCountryGate, resolveCountryGate } from "./utils/countryGate";
import i18n, { applyLocaleFromGate } from "./utils/i18n";
// Thai typography — every rule is scoped to html[lang="th"], so SG is untouched.
import "./assets/css/thai.css";

// import { WebsiteRoute } from './router/website.js';

// Vue.use(viewer) removed → v-viewer lazy-installed via the auth gate in router/index.js (src/utils/viewer.js).
// Vue.use(mDatePicker) removed → vue-multi-date-picker was dead.

Vue.mixin({
  methods: {
    isApp: function() {
      // If ?app=yes in URL, return true
      console.log(this.$route.query.app,'++++++++++++++++++++')
      // return this.$route.query.app === 'yes';
      if(this.$route.query.app === 'yes'){
        return false;
      }
      else{
        return true;
      }
    },
    isAppView: function(){
      return ['jobseeker', 'employer'].includes(this.$route.query.app)
    },
    isDarkTheme: function(){
      return this.$route.query.theme === 'dark'
    }
  },
  metaInfo() {
    const webUrl = process.env.VUE_APP_URL;
    let canonicalUrl;
  
    if (this.$route && this.$route.name === 'allDailyPaidJoblisting') {
      // Full current path — do NOT truncate at '/all-'. The old `.split('/all-')[0]` broke every
      // category/combo canonical (e.g. `/Cleaning` instead of `/Cleaning/all-companies-jobs`, and
      // combos collapsed to the root). This mixin wins vue-meta's vmid dedup, so it must be correct.
      const pathBeforeAll = this.$route.path;
  
      // Build query string without 'filter'
      const query = { ...this.$route.query };
      delete query.filter;
  
      const queryString = Object.keys(query).length
        ? '?' + Object.entries(query).map(([k, v]) => `${k}=${v}`).join('&')
        : '';
  
      // Combine base URL + path + query string
      canonicalUrl = webUrl.replace(/\/$/, '') + pathBeforeAll + queryString;
    } else {
      canonicalUrl = webUrl.replace(/\/$/, '') + ((this.$route && this.$route.path && this.$route.path !== '/') ? this.$route.path : '');
    }
  
    const currentUser =
      this.$store && this.$store.getters
        ? this.$store.getters.currentUser
        : null;
  
    if (currentUser && currentUser.user_type_id != null) {
      return {};
    }
  
    let ogType = 'website';
    if (this.$route && this.$route.name === 'blogDetail') {
      ogType = 'article';
    }

    // AJ-6: nginx serves every unmatched URL as a 200 SPA shell, and the `*` catch-all lands on
    // /error-404 — so a dead URL looks like a real page to a crawler (that is how /job-listing got
    // indexed as "Page Not Found"). `noindex` is the only 404 signal the client can send, so emit it
    // for the error route. It has to live in THIS mixin, not in Error404.vue: the mixin is global, so
    // every component (navbar, footer, …) contributes the same vmid, and whichever renders last wins
    // vue-meta's dedup — a per-page override of a mixin tag gets clobbered by the route's siblings.
    // (The other tags here get away with it only because every component computes an identical value.)
    // The matching static default lives in public/index.html with the same vmid, so vue-meta replaces
    // that tag instead of appending a second, conflicting robots directive.
    //
    // The same tag also keeps the logged-in APP out of the index. robots.txt disallows /admin/,
    // /account/ and /dashboard/, but the app actually lives under /v2/admin, /v2/employer and
    // /v2/jobseeker — ~390 routes none of those rules match — so every one of them was crawlable and
    // served the SPA shell, which is the "identical titles" cluster Bing reports. The signal used is
    // the router's own `requiresAuth`, not a list of path prefixes: it is already set on 386 of the
    // 392 /v2/ routes, so it stays correct as routes are added, and it cannot catch a public page by
    // accident. `showFor` looks like the same signal but is NOT — it is set on the homepage and on
    // /employer, so keying off it would deindex those. The extra /v2/ clause covers the handful of
    // app routes that never got a requiresAuth flag (e.g. /v2/employer/checkout) while leaving the
    // ones marked `requiresAuth: false` — the public elucky-draw pages — indexable.
    const routeName = this.$route && this.$route.name;
    const routePath = (this.$route && this.$route.path) || '';
    const routeMeta = (this.$route && this.$route.meta) || {};
    const isErrorRoute = routeName === 'error-404' || routePath === '/error-404';
    const isAppRoute =
      routeMeta.requiresAuth === true ||
      (routePath.indexOf('/v2/') === 0 && routeMeta.requiresAuth !== false);
    const robotsDirective = isErrorRoute || isAppRoute ? 'noindex, follow' : 'index, follow';
  
    return {
      link: [
        {
          rel: 'canonical',
          href: canonicalUrl,
          vmid: 'canonical'
        }
      ],
      meta: [
        {
          property: 'og:url',
          content: canonicalUrl,
          vmid: 'og:url'
        },
        {
          property: "og:site_name",
          content: "EL Connect",
          vmid: 'og:site_name'
        },
        {
          property: "og:type",
          content: ogType,
          vmid: 'og:type'
        },
        {
          name: "twitter:card", 
          content: "summary_large_image",
          vmid: 'twitter:card'
        },
        {
          name: "robots",
          content: robotsDirective,
          vmid: 'robots'
        }
      ]
    };
  }
  
});


// sweetalert2: lazy-loaded on first use instead of the global Vue.use (kept off the initial bundle).
// Only Swal.fire is used app-wide, so this covers this.$swal(...), this.$swal.fire(...), AND the bare
// global Swal.fire(...) in ~11 components (which were broken before — window.Swal was never set).
import lazySwal from "./utils/swal";
Vue.prototype.$swal = lazySwal;
if (!window.Swal) window.Swal = { fire: lazySwal };
if (process.env.is_prod === "yes") {
  // no-ops for all console methods
  ["log"].forEach((method) => {
    console[method] = () => {};
  });
}
Vue.config.productionTip = false;
Vue.use(BootstrapVue);

// bootstrap-vue focuses the dropdown <ul.dropdown-menu> when a b-dropdown opens, without
// preventScroll — if the menu isn't positioned yet (boundary="window" menus inside the
// position:relative dashboard wrapper transiently sit at the wrapper's bottom), the browser
// scrolls the page to the bottom of the list. Menu-element focus only; item focus untouched.
(function () {
  const origFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function (options) {
    if (this.classList && this.classList.contains("dropdown-menu")) {
      options = Object.assign({ preventScroll: true }, options);
    }
    return origFocus.call(this, options);
  };
})();
Vue.use(VueLazyload);

Vue.use(VueSocialSharing);

Vue.use(VueMeta);

Vue.use(VueAxios, axios);

// Serve all images via the DO Spaces CDN edge: rewrite every `X.sgp1.digitaloceanspaces.com` (origin)
// to the CDN host in every axios response. Registered HERE (not in ApiService.init(), which is never
// called) so it actually runs. Documents/archives (invoices/resumes/etc.) stay on the ORIGIN — skipped.
// Idempotent (already-CDN unchanged); acyclic JSON so recursion is safe.
const _CDN_RE = /(\.sgp1)\.digitaloceanspaces\.com/g;
const _SKIP_CDN_EXT = /\.(xlsx?|xlsm|xlsb|xlt[xm]?|csv|pdf|docx?|docm|dot[xm]?|rtf|odt|zip|zipx|rar|7z|tar|gz|tgz|bz2|xz)(\?|#|$)/i;
const _cdnifyDeep = (v) => {
  if (typeof v === "string") return _SKIP_CDN_EXT.test(v) ? v : v.replace(_CDN_RE, "$1.cdn.digitaloceanspaces.com");
  if (Array.isArray(v)) { for (let i = 0; i < v.length; i++) v[i] = _cdnifyDeep(v[i]); return v; }
  if (v && typeof v === "object") { for (const k in v) if (Object.prototype.hasOwnProperty.call(v, k)) v[k] = _cdnifyDeep(v[k]); return v; }
  return v;
};
axios.interceptors.response.use(
  (response) => { if (response && response.data) response.data = _cdnifyDeep(response.data); return response; },
  (error) => Promise.reject(error)
);

//window.Swal = Swal

// Google Maps (vue2-google-maps wrapper + GmapCluster) is now lazy-loaded ONLY on routes that
// render an interactive <GmapMap> — see src/utils/googleMaps.js and the MAP_ROUTE_NAMES guard in
// src/router/index.js. Removing the global Vue.use keeps the maps wrapper out of the initial bundle
// so public pages (which use only an <iframe> or the raw google.maps API) don't parse/eval it.

// const Toast = Swal.mixin({
//   toast: true,
//   position: 'top-end',
//   showConfirmButton: false,
//   timer: 3000
// });

Vue.prototype.encrypt = function (value) {
  // return this.CryptoJS.AES.encrypt(value.toString(),"elconnect%db@2020").toString()
  return btoa(value);
};

Vue.prototype.decrypt = function (value) {
  return atob(value);
};

// Route DigitalOcean Spaces images through the CDN edge host. Some DB-stored URLs use the slower
// ORIGIN (`X.sgp1.digitaloceanspaces.com`) instead of the CDN (`X.sgp1.cdn.digitaloceanspaces.com`) —
// inconsistent over time. This rewrites origin → CDN; already-CDN URLs are left unchanged (idempotent).
Vue.prototype.cdnUrl = function (value) {
  return String(value || "").replace(/(\.sgp1)\.digitaloceanspaces\.com/, "$1.cdn.digitaloceanspaces.com");
};

moment.locale("en");

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/serviceworker.js")
    .then((reg) => console.log("service worker registered", reg))
    .catch((err) => console.log("service worker not registered", err));
}

// moment.tz.setDefault('Asia/Singapore')

//window.Toast = Toast;

/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
  // ['site-navigation-schema', 'job-posting-schema', 'common-local-business-schema', 'job-breadcrumb-schema', 'job-item-list-schema', 'job-web-page-schema'].forEach(id => {
  //   const el = document.getElementById(id);
  //   if (el) el.remove();
  // });
  document.querySelectorAll('script[type="application/ld+json"]').forEach((el) => {
    el.parentNode.removeChild(el);
  });
  // Re-inject the site-wide LocalBusiness schema after the per-route ld+json wipe (Semrush "Local
  // Schema" + geo/hours/phone). This is what survives into the prerendered + raw HTML on every route
  // (static index.html blocks get wiped by the loop above; the per-route schemas re-inject by id).
  injectJsonLd('local-business-schema', LOCAL_BUSINESS);
  next();
});

// Country gate (Thailand expansion, THAILAND.md §11.0) — resolved BEFORE mount so
// the first render already knows the country.
//
// SAFETY: mounting the app must NEVER depend on the gate succeeding. Every step
// below is wrapped so that any failure (network, timeout, bad payload, throw)
// still reaches mountApp() with the gate closed — i.e. today's English Singapore
// UI. A broken gate must degrade to the old behaviour, never to a blank page.
function mountApp() {
  new Vue({
    el: "#app",
    router,
    store,
    i18n,
    template: "<App/>",
    components: {
      App,
    },
  });
}

try {
  installCountryGate(Vue);
} catch (e) {
  // $isTH falls back to false via the module's own default state.
}

Promise.resolve()
  .then(() => resolveCountryGate())
  // Locale follows the gate — the country profile decides the language
  // (config/countries.js); gate closed or failed always means SG/en.
  .then((gate) => applyLocaleFromGate(gate))
  .catch(() => {
    // Gate unavailable — stay on the English default and mount anyway.
  })
  .then(mountApp);
